module.exports = __webpack_public_path__ + "6767ad66ee7574893b22aef1438e182a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/mariko-kosaka.jpg
 ** module id = 420
 ** module chunks = 0
 **/